import { render } from "./AwardsWithMobileSlider.vue?vue&type=template&id=0e3bfccc&scoped=true&ts=true"
import script from "./AwardsWithMobileSlider.vue?vue&type=script&lang=ts"
export * from "./AwardsWithMobileSlider.vue?vue&type=script&lang=ts"

import "./AwardsWithMobileSlider.vue?vue&type=style&index=0&id=0e3bfccc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3bfccc"]])

export default __exports__